// extracted by mini-css-extract-plugin
export default {"pixContainer":"pixOption_pixContainer__IFjMp","pixLogo":"pixOption_pixLogo__jNqGn","pixLabel":"pixOption_pixLabel__2MMla","approvalTag":"pixOption_approvalTag__BWZL7"};